import { createAction, props } from '@ngrx/store';
import { ApiActionLogListResponseDto } from '@birco/rainmesh-api';
import { ActionLogFilter } from './action-log.state';

const ACTION_PREFIX = '[ActionLog]';

export const ActionLogActions = {
  public: {
    updateActionLogFilter: createAction(
      `${ACTION_PREFIX} updateActionLogFilter`,
      props<{
        filter: ActionLogFilter;
      }>(),
    ),
  },

  private: {
    loadActionLogWithFilters: createAction(
      `${ACTION_PREFIX} loadActionLogWithFilters`,
    ),

    loadActionLogSuccess: createAction(
      `${ACTION_PREFIX} loadActionLogSuccess`,
      props<{
        actionLogResponseDto: ApiActionLogListResponseDto;
      }>(),
    ),

    loadActionLogFailure: createAction(
      `${ACTION_PREFIX} loadActionLogFailure`,
      props<{
        error: any;
      }>(),
    ),
  },
};
